(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('RestrictedDialogController', RestrictedDialogController);

    function RestrictedDialogController($scope, $mdDialog, $state, $sce, $timeout, $compile, email, model, flagsService, $translate, $sanitize) {

        // Compile the div that contains the extra info
        // This is needed to make sure angular bindings work
        // e.g. ng-clicks
        if (model.me.restricted_reason === 'CUSTOMER_ACCOUNT_DELETED') {
            $timeout(function () {

                // Taken from Stack Overflow but lost the link :/
                // Yes the -9999 is important
                return $compile(angular.element('#restricted-dialog .text>div'), null, -9999)($scope);
            }, 0);
        }

        $scope.model = model;
        $scope.textmap = {
            'TRIAL_EXPIRED': {
                true: {
                    title: $translate.instant('Uh-oh! Your Salesflare free trial just ended.'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Subscribe below to continue working. You\'ll keep:')
                            + '<ul>'
                            + '    <li>' + $translate.instant('Your fully automatic address book and to do list.') + '</li>'
                            + '    <li>' + $translate.instant('Access to the Salesflare apps, plugins and integrations.') + '</li>'
                            + '    <li>' + $translate.instant('All premium Salesflare intelligence features.') + '</li>'
                            + '</ul>'
                        + '</p>'),
                    button: $translate.instant('Subscribe')
                },
                false: {
                    title: $translate.instant('Uh-oh! Your Salesflare free trial just ended.'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To continue working, ask your administrator to subscribe. You\'ll keep:')
                            + '<ul>'
                            + '    <li>' + $translate.instant('Your fully automatic address book and to do list.') + '</li>'
                            + '    <li>' + $translate.instant('Access to the Salesflare apps, plugins and integrations.') + '</li>'
                            + '    <li>' + $translate.instant('All premium Salesflare intelligence features.') + '</li>'
                            + '</ul>'
                        + '</p>')
                }
            },
            'STRIPE_SUBSCRIPTION_CANCELED': {
                true: {
                    title: $translate.instant('Uh-oh! Your payment keeps failing'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Update your credit card information to keep using Salesflare. You might need to contact your bank to resolve the issue.')
                        + '</p>'),
                    button: $translate.instant('Fix payment')
                },
                false: {
                    title: $translate.instant('Uh-oh! Your team\'s payment keeps failing'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, ask your administrator to update the credit card information and/or to check with the bank to resolve the issue.')
                        + '</p>')
                }
            },
            'CUSTOMER_ACCOUNT_DELETED': {
                true: {
                    title: $translate.instant('Uh-oh! Your payment account has been deleted'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Contact support at') + ' <a ng-click="mailto(\'support@salesflare.com\', $event)">support@salesflare.com</a> ' + $translate.instant('to resolve the issue.')
                        + '</p>')
                },
                false: {
                    title: $translate.instant('Uh-oh! Your payment account has been deleted'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Contact support at') + ' <a ng-click="mailto(\'support@salesflare.com\', $event)">support@salesflare.com</a> ' + $translate.instant('to resolve the issue.')
                        + '</p>')
                }
            },
            'BRIEFCASE_CANCELED': {
                true: {
                    title: $translate.instant('Uh-oh! You canceled your Briefcase account'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, you can subscribe to one of our plans.')
                        + '</p>'),
                    button: $translate.instant('Subscribe')
                },
                false: {
                    title: $translate.instant('Uh-oh! You canceled your Briefcase account'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, ask your administrator to subscribe to one of our plans.')
                        + '</p>')
                }
            },
            'SCA_REQUIRED': {
                true: {
                    title: $translate.instant('Uh-oh! Extra authentication required'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Because of European regulation to protect consumers, your bank requires extra authentication on your latest payment.')
                        + '</p>'),
                    button: $translate.instant('AUTHENTICATE'),
                    buttonGoTo: 'settings.billingSettings.overview'
                },
                false: {
                    title: $translate.instant('Uh-oh! Extra authentication required'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Because of European regulation to protect consumers, your bank requires extra authentication on your latest payment. Ask your administrator to do this in Settings > Billing.')
                        + '</p>')
                }
            },
            'PAYMENT_FAILED': {
                true: {
                    title: $translate.instant('Uh-oh! Your payment failed'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('Update your credit card information to keep using Salesflare. You might need to contact your bank to resolve the issue.')
                        + '</p>'),
                    button: $translate.instant('FIX PAYMENT'),
                    buttonGoTo: 'settings.billingSettings.overview'
                },
                false: {
                    title: $translate.instant('Uh-oh! your payment failed'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, ask your administrator to update the credit card information and/or to check with the bank to resolve the issue.')
                        + '</p>')
                }
            },
            'FREEMIUM_CANCELED': {
                true: {
                    title: $translate.instant('Uh-oh! Salesflare\'s free plan is no longer available'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, you can subscribe to one of our plans.')
                        + '</p>'),
                    button: $translate.instant('Subscribe')
                },
                false: {
                    title: $translate.instant('Uh-oh! Salesflare\'s free plan is no longer available'),
                    text: $sce.trustAsHtml('<p>'
                            + $translate.instant('To keep using Salesflare, you can subscribe to one of our plans.')
                        + '</p>')
                }
            },
            'APPSTACK_LICENSE_SUSPENDED': {
                true: {
                    title: $translate.instant('Uh-oh! Your Salesflare license through Samsung AppStack was suspended.'),
                    text: $sce.trustAsHtml('<p>' + $translate.instant('To keep using Salesflare, you can resume your Salesflare license in <a href="{{url}}" target="_blank" rel="noopener">your Samsung Business account</a>.', { url: 'https://www.samsung.com/us/business/account/login/' }) + '</p>')
                },
                false: {
                    title: $translate.instant('Uh-oh! Your Salesflare license through Samsung AppStack was suspended.'),
                    text: $sce.trustAsHtml('<p>' + $translate.instant('To keep using Salesflare, you can resume your Salesflare license in <a href="{{url}}" target="_blank" rel="noopener">your Samsung Business account</a>.', { url: 'https://www.samsung.com/us/business/account/login/' }) + '</p>')
                }
            },
            'APPSTACK_LICENSE_CANCELED': {
                true: {
                    title: $translate.instant('Uh-oh! Your Salesflare license through Samsung AppStack was canceled.'),
                    text: $sce.trustAsHtml('<p>'
                        + $translate.instant('Please') + ' <a id="intercom-chat-button" ng-click="mailto(\'support@salesflare.com\', $event)">' + $translate.instant('contact support') + '</a> ' + $translate.instant('to resolve the issue.')
                        + '</p>')
                },
                false: {
                    title: $translate.instant('Uh-oh! Your Salesflare license through Samsung AppStack was canceled.'),
                    text: $sce.trustAsHtml('<p>'
                        + $translate.instant('Please') + ' <a id="intercom-chat-button" ng-click="mailto(\'support@salesflare.com\', $event)">' + $translate.instant('contact support') + '</a> ' + $translate.instant('to resolve the issue.')
                        + '</p>')
                }
            }
        };

        $scope.extend = function () {

            return $mdDialog.show({
                escapeToClose: false,
                clickOutsideToClose: false,
                templateUrl: 'partials/extendtrialdialog.html',
                controller: 'ExtendTrialDialogController'
            });
        };

        $scope.getRich = function () {

            return $mdDialog.hide().then(function () {

                return $state.go($scope.textmap[model.me.restricted_reason][!!model.me.is_admin].buttonGoTo || 'plans');
            });
        };

        $scope.canExtendTrial = function () {

            if (!model.me) {
                return false;
            }

            if (flagsService.get('gamifiedTrial') === false) {
                return !model.me.trial_extended;
            }

            return !model.me.trial_extended && model.me.amount_of_trial_days_earned <= 21;
        };

        $scope.mailto = email.mailto;

        $scope.getTrialEmailHintHtml = function () {
            const raw = $translate.instant('If you still haven\'t had the opportunity to trial Salesflare fully, feel free to email us at <a href="">support@salesflare.com</a>.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        $scope.handleTrialEmailHintClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                $scope.mailto('support@salesflare.com', $event);
            }
        };
    }
})();
